module.exports = __webpack_public_path__ + "static/media/iconLibraryNumeric.3b73ba69.svg";